<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  dismissPushBanner,
  requestPushPermissions,
  shouldOfferPush,
} from 'dashboard/helper/pushHelper';

const { t } = useI18n();
const isVisible = ref(false);

onMounted(async () => {
  isVisible.value = await shouldOfferPush();
});

const hide = () => {
  isVisible.value = false;
};

const dismiss = () => {
  dismissPushBanner();
  hide();
};

const enable = () => {
  requestPushPermissions({ onSuccess: hide, onDenied: dismiss });
};
</script>

<template>
  <Banner
    v-if="isVisible"
    color="blue"
    class="!rounded-none !justify-center"
    data-test-id="push-permission-banner"
    :action-label="t('PUSH_PERMISSION_BANNER.ENABLE')"
    @action="enable"
  >
    <span class="text-xs">{{ t('PUSH_PERMISSION_BANNER.MESSAGE') }}</span>
    <button
      type="button"
      class="ms-2 align-middle"
      data-test-id="push-permission-banner-dismiss"
      :aria-label="t('PUSH_PERMISSION_BANNER.DISMISS')"
      @click="dismiss"
    >
      <Icon icon="i-lucide-x" class="size-3.5" />
    </button>
  </Banner>
</template>
